export const routeForAuthorisationDashboard = '/settings';
export const routeForUsers = '/settings/users';
export const routeForUser = '/settings/users/:id';
export const routeForUserPermissions = '/settings/users/:id/permissions';

export type UserRouteParams = {
    id: string;
};

export const routeForNewUser = '/settings/users/new';

export const getUserRoute = (userId: string): string => {
    return `/settings/users/${userId}`;
};

export const getUserPermissionsRoute = (userId: string): string => {
    return `/settings/users/${userId}/permissions`;
};

export const routeForGroups = '/settings/groups';
export const routeForNewGroup = '/settings/groups/new';
export const routeForGroup = '/settings/groups/:id';
export const routeForGroupPermissions = '/settings/groups/:id/permissions';

export type GroupRouteParams = {
    id: string;
};

export const getGroupRoute = (groupId: string): string => {
    return `/settings/groups/${groupId}`;
};

export const getGroupPermissionsRoute = (groupId: string): string => {
    return `/settings/groups/${groupId}/permissions`;
};
